import React, { useContext, useState } from "react";
import { IconChevronDown } from "@tabler/icons-react";
import { CButton } from "@app/components/Common";
import { COLORS } from "@app/constants";
import { View } from "@/styles/reactnative";
import { ThemeContext } from "@/theme/ThemeProvider";
import { useTranslation } from "react-i18next";

const ConvertTypeCoin = () => {
  const { t } = useTranslation();
  const { gray, grey, textw, textsilver } =
    useContext(ThemeContext).theme.COLORS;

  const [convertType, setConvertType] = useState("BTC");
  const [display, setDisplay] = useState<boolean>(false);
  const list = ["USDT"];
  return (
    <View style={{ width: "40%", height: 30, background: gray }}>
      <CButton
        title={convertType}
        onClick={() => setDisplay(!display)}
        icon={<IconChevronDown size={10} />}
        style={{
          height: "100%",
          width: "100%",
          color: textw,
          justifyContent: "space-between",
        }}
      />
      {display ? (
        <View
          style={{
            position: "absolute",
            width: "32%",
            background: grey,
            zIndex: 99,
            marginTop: 135,
          }}
        >
          {list?.map((item, index) => (
            <CButton
              key={index.toString()}
              title={t(item)}
              onClick={() => {
                setConvertType(item);
                setDisplay(!display);
              }}
              backgroundHover={textsilver}
              style={{
                width: "100%",
                alignItems: "flex-start",
                padding: 5,
                cursor: "pointer",
                color: convertType === item ? COLORS.primary : textw,
              }}
            />
          ))}
        </View>
      ) : null}
    </View>
  );
};

export default ConvertTypeCoin;
